import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyAYZQCGGQF7eKDHoFigyvLaUXCLBB5MkTA",
  authDomain: "qrproperties.firebaseapp.com",
  projectId: "qrproperties",
  storageBucket: "qrproperties.firebasestorage.app",
  messagingSenderId: "716792552062",
  appId: "1:716792552062:web:ed14a6867f436ca26b162f",
  measurementId: "G-MVVTMF6LPF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export default app;
